<template>
  <div class="page_edit">
    <com-header></com-header>
    <div class="box_full">
      <com-menu @msg-menu="msg_menu_fn"></com-menu>
      <div class="content">
        <div class="box">
          <div class="box_left">
            <div class="box_material" :class="box_material_more">
              <com-material v-on:add_ueditor_value="add_ueditor_value_fn" v-show="idx == 0"></com-material>
              <com-template
                v-on:add_ueditor_value="add_ueditor_value_fn"
                v-on:pop_preview="pop_preview_fn"
                v-show="idx == 1">
              </com-template>
              <!-- <com-picture
                ref="picture"
                v-on:add_ueditor_value="add_ueditor_value_fn"
                v-show="idx == 2">
              </com-picture> -->
              <com-copywriting
               v-on:pop_preview="pop_preview_fn"
                v-on:add_ueditor_value="add_ueditor_value_fn"
                v-show="idx == 2"
                @addAricleId="articleFun">
              </com-copywriting>
              <com-collection v-on:add_ueditor_value="add_ueditor_value_fn" v-show="idx == 5"></com-collection>
            </div>
            <div class="box_btn">
              <div v-show="btn_state != 0" class="less" @click="btn_fn('less')"></div>
              <div v-show="btn_state != 2" class="more" @click="btn_fn('more')"></div>
            </div>
          </div>
          <div class="box_edit" >
            <vue-ueditor-wrap
              height="100%"
              @ready="ready"
              v-model="ueditor_value"
              :config="ueditor_config">
            </vue-ueditor-wrap>
            <com-poput class="poput" :colorPool="colorPool" :value="value_poput"></com-poput>
            <com-unit class="unit" @add_ueditor_value="add_ueditor_value_fn" v-on:pop_preview="pop_preview_fn" :article-id="articleIds">{{articleIds}}</com-unit>
            <div v-show="show_load" class="peeek-loading">
              <ul>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </div>
          </div>
          <div class="right-nav" >
            <right-asilde @add_ueditor_value="add_ueditor_value_fn"></right-asilde>
          </div>
        </div>
      </div>
    </div>
    <com-preview
      v-show="show_preview"
      v-bind:preview_value="preview_value"
      v-on:close_preview="close_preview_fn"
      :obj-id="articlesIds">
    </com-preview>
    <!-- 注册 -->
    <!-- <com-register></com-register> -->
  </div>
</template>

<script>
import comMenu from "../components/com-menu";
import comUnit from "../components/com-unit";
import comPoput from "../components/com-poput";
import comHeader from "../components/com-header";
import comMaterial from "../components/com-material";
import comCollection from "../components/com-collection";
import comCopywriting from "../components/com-copywriting";
import comRegister from "../components/com-register";
import comTemplate from "../components/com-template";
import comPicture from "../components/com-picture";
import comPreview from "../components/com-preview";
import VueUeditorWrap from "vue-ueditor-wrap";
import "../assets/css/loader.scss";
import { setTimeout, clearTimeout } from "timers";
// import { log } from "util";
import DomSize from "wd-domsize-monitor";
import rightAsilde from '@/components/rightAsilde/right-asilde'
import ArticleService from '@/service/api/articleService'
import { watch } from 'fs';

export default {
  data: function() {
    return {
      box_material_more: "",
      btn_state: 1,
      show_load: 1,
      show_preview: 0,
      value_poput: [100, 0, 100],
      ueditor_value: "",
      preview_value: {},
      lastEditRange: 0,
      colorPool: [],
      lastEditRange: 0,
      ueditor_config: {
        serverUrl: "http://user.ihuyi.com/wxeditor/api/upload.php",
        initialFrameHeight: window.innerHeight - 120 - 25,
        autoHeightEnabled: false,
        UEDITOR_HOME_URL:
          process.env.NODE_ENV == "development"
            ? "../../static/UEditor/"
            : "/static/UEditor/"
      },
      idx: 0,
      dropdown_data_title: [
        { text: "编号标题", isActive: true },
        { text: "线框标题", isActive: false },
        { text: "底色标题", isActive: false },
        { text: "图片标题", isActive: false }
      ],
      articleIds: null,
      timer: null,
      articlesIds: null
    };
  },
  methods: {
    saveArticles () {
      const articleSystem = new ArticleService()
      const obj = {
        content: this.ueditor_value.split("active").join(""),
        type: 0
      }
      articleSystem.saveArticles(obj)
        .then(() => {
          this.$notify.success('已自动保存，每2分钟一次')
          this.timer = setTimeout(() => {
            this.saveArticles()
          }, 120000)
        }, (error) => {
        this.$notify.error(error.message)
        })
    },
    //编辑器加载
    ready(editorInstance) {
      editor = editorInstance;
      this.ueditor_value = window.localStorage["data"];
      this.show_load = 0;
      var self = this;
      window.onresize = function temp() {
        document.querySelector(
          "#edui1_iframeholder"
        ).style.height = `${window.innerHeight - 145 - 25}px`;
      };

      let t = $("#ueditor_0")
        .contents()
        .find("#edui1_toolbarbox");
      let t_w = parseFloat(t.css("width"));
      let t_h = parseFloat(t.css("height"));
      let top = $("header").css("height");
      t.css({ position: "fixed", top: `${top}px` });
      $("#ueditor_0")
        .contents()
        .find("#edui1_iframeholder")
        .css({ top: `${top + t_h}px` });

      $("#ueditor_0")
        .contents()
        .find("body")
        .on("click", function(event) {
          let ev = event || window.event;
          let et = ev.target;

          $(choose_node).removeClass("active");
          $("#poputColor").hide();
          $("#poput").hide();
          if (
            et.className.indexOf("ihuyiEditor") != -1 ||
            $(et).parents(".ihuyiEditor").length != 0
          ) {
            choose_node =
              et.className.indexOf("ihuyiEditor") != -1
                ? $(et)
                : $(et).parents(".ihuyiEditor");
            $(choose_node).addClass("active");

            let o = parseFloat($(choose_node).css("opacity")),
              d = 0;

            if ($(choose_node).css("transform") != "none") {
              d = eval("get" + $(choose_node).css("transform"));
            }

            let w = Math.round(
              $(choose_node)
                .width()
                .div(557) * 100
            );

            self.value_poput = [o * 100, d, w];

            self.initColorPool($(choose_node).find("*"));

            $("#poput")
              // .css({ top: choose_node.left, left: choose_node.right })
              .show();
          }
        });
      setInterval(() => {
        window.localStorage["data"] = this.ueditor_value
          .split("active")
          .join("");
      }, 1000);
      if(this.ueditor_value) this.saveArticles()
    },
    //弹窗
    initColorPool(nodePool) {
      function isGreyColor(color) {
        var val = rgb2hex(color);
        var reg = /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/;
        if (reg.test(val)) {
          return true;
        }
        return false;
      }
      var colorPool = {},
        i = 0,
        oldColor,
        attrPool = [
          "borderBottomColor",
          "borderTopColor",
          "borderLeftColor",
          "borderRightColor",
          "color",
          "backgroundColor"
        ];

      nodePool.each(function(n, node) {
        if (node && node.nodeType == 1) {
          attrPool.map(e => {
            oldColor = node.style[e];
            if (oldColor && isGreyColor(oldColor)) {
              if (!colorPool[oldColor]) {
                colorPool[oldColor] = [];
              }
              colorPool[oldColor].push({ node: node, attr: e });
            }
          });
        }
      });
      this.colorPool = [];
      Object.keys(colorPool).forEach((c) => {
        this.colorPool.push({ color: c, it: colorPool[c] });
      });
    },
    articleFun(val) {
      this.getArticle(val.id)
    },
    getArticle(id) {
      const articleSystem = new ArticleService()
      articleSystem.lookArticle({id: id})
        .then(({data}) => {
          this.articlesIds = data.data
          console.log(this.articlesIds, 3444)
        }, (error) => {
        this.$notify.error(error.message)
      })
    },
    //添加编辑器内容
    add_ueditor_value_fn(msg) {
      console.log(msg, 999)
      if (!msg.types){
        this.articleIds = msg
      }
      var range = editor.selection.getRange();
      range.select();
      var txt = editor.selection.getText();
      if (txt != "") {
        var node = $("<div></div>").html(msg.content);
        node.find("p").text(txt);
        msg.content = node.html();
      }
      editor.execCommand("inserthtml", `${msg.content}`);
      this.ueditor_value = editor.getContent();
    },
    //左边菜单栏
    msg_menu_fn(idx) {
      this.idx = idx;
      // if (this.idx == 2) {
      //   this.$refs["picture"].$emit("msg-waterfallInit");
      // }
    },
    //预览 显示
    pop_preview_fn(data) {
      this.show_preview = 1;
      if (data) {
        this.preview_value = data;
      } else {
        this.preview_value = this.ueditor_value;
      }
    },
    //预览 隐藏
    close_preview_fn() {
      this.show_preview = 0;
    },
    //素材扩展
    btn_fn(name) {
      switch (name) {
        case "less":
          this.btn_state -= 1;
          break;
        case "more":
          this.btn_state += 1;
          break;
      }
      if (this.btn_state == 0) {
        this.box_material_more = "bm_0";
      } else if (this.btn_state == 1) {
        this.box_material_more = "";
        this.$refs["picture"].$emit("msg-waterfall385");
      } else if (this.btn_state == 2) {
        this.box_material_more = "bm_1";
        this.$refs["picture"].$emit("msg-waterfall755");
      }
    }
  },
  mounted() {
    //瀑布流高度适配
    $.each($(".navResize"), (i, e) => {
      DomSize.bind(e, function() {
        let t = $(this.el).height();
        let n = $(this.el)
          .parent()
          .children(".resultResize");
        if (t == 0) return;
        n.css("top", `${t}px`);
      });
    });
  },
  destroyed () {
    clearTimeout(this.timer)
  },
  components: {
    comUnit,
    comMenu,
    comPoput,
    comHeader,
    comPreview,
    comPicture,
    comRegister,
    comMaterial,
    comTemplate,
    comCollection,
    comCopywriting,
    VueUeditorWrap,
    rightAsilde
  }
};
</script>

<style lang="scss" scoped>
.page_edit {
  width: 100%;
  height: 100%;
  min-width: 1280px;
  font-size: 16px;
  overflow: hidden;
  background-color: #f1f3f7;
  .box_full {
    display: flex;
    height: 100%;
    width: 100%;
    padding-top: 60px;
    box-sizing: border-box;
  }
  .box_edit {
    position: relative;
    width: 585px;
    margin: 0 auto;
    margin-right: 108px;
  }
  .content {
    width: 100%;
    height: 100%;
    padding-left: 110px;
    .box {
      height: 100%;
      // min-width: 1080px;
      display: flex;
      // width: 100%;
      margin-right: 100px;
    }
  }
  .unit {
    position: absolute;
    right: -110px;
    top: 43%;
    z-index: 999;
  }

  .box_left {
    position: relative;
    padding-right: 40px;
  }

  .box_material {
    min-width: 385px;
    width: 385px;
    height: 100%;

    &.bm_0 {
      display: none;
    }

    &.bm_1 {
      min-width: 755px;
      width: 755px;
    }
  }

  .box_btn {
    width: 37px;
    position: absolute;
    top: 50%;
    right: 0;
    z-index: 5;
    margin-top: -77px;
    display: flex;
    justify-content: space-between;
    div {
      cursor: pointer;
      width: 18px;
      height: 77px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-image: url(../assets/images/material_less.png);
      &:last-child {
        transform: rotateZ(180deg);
      }
      &:hover {
        background-image: url(../assets/images/material_more.png);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/page-edit.vue